import {
    useCallback,
} from 'react'
import {
    useDispatch,
} from 'react-redux'
import {
    useMutation,
} from '@tanstack/react-query'

import aPricingRateCardRequests from 'app/requests/APricingRateCard/APricingRateCard.requests'
import simpleApi from 'app/services/simpleApi'
import {
    useJWTToken,
} from 'app/Auth'
import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'
import {
    RateCardStatus,
} from 'app/enums/label.enums'
import {
    successedToSaveForm,
} from 'app/shared-components/FormStatuses/store/actions'

type Params = {
    onSuccess: (...args: any[]) => void,
}

type MutationParams = {
    id: number,
    status: RateCardStatus,
    title: string,
}

const NOTIFICATION_ID = 'ARateCardStatusChange'

export default ({
    onSuccess: onSuccessExternal,
}: Params) => {
    const token = useJWTToken()
    const dispatch = useDispatch()

    const {
        onError,
    } = useHandleStatusRequest({
        id: NOTIFICATION_ID,
    })

    const mutation = useMutation({
        mutationFn: ({
            id,
            status,
        }: MutationParams) => {
            return simpleApi({
                ...aPricingRateCardRequests.setStatus({
                    id,
                    status,
                }),
                token,
            })
        },
        onError,
        onSuccess: (data, variables) => {
            dispatch(
                successedToSaveForm({
                    id: NOTIFICATION_ID,
                    title: variables.title,
                }),
            )
            onSuccessExternal(data)
        },
    })

    const changeStatus = useCallback((params: MutationParams) => {
        mutation.mutate(params)
    }, [mutation])

    return {
        changeStatus,
        isPending: mutation.isPending,
    }
}
